// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.soldStockReports', {
        url: '/soldstockreports',
        views: {
            "wideColumnView@stock": {
                templateUrl: 'main/stock/reports/soldStockReports.tpl.html',
                controller: 'SoldStockReportsController as vm'
            }
        },
        resolve: {
            locations: locationsResolver,
            companies: companiesResolver
        }
    });
}

// @ngInject
function locationsResolver(StockApiService) {
    return StockApiService.getLocations();
}

// @ngInject
function companiesResolver(StockApiService) {
    return StockApiService.getCompaniesBrief();
}

// @ngInject
function SoldStockReportsController($translate, StockApiService, locations, loadSpinnerService, companies) {
    var vm = this;

    //Properties
    vm.reportParameters = {
        startDate: new Date(),
        endDate: new Date(),
        locationIds: [],
        companyIds: [],
        sortOrder1: undefined,
        sortOrder2: undefined,
        sortOrder3: undefined
    };
    vm.selectedLocations = [];
    vm.selectedCompanies = [];
    vm.sortorders = [];
    vm.sortOrder2 = undefined;
    vm.sortOrder3 = undefined;
    vm.printLanguage = 'se';
    vm.locations = locations;
    vm.companies = companies;
    vm.selectedLocations = angular.copy(locations);
    vm.includeStorageItems = false;
    vm.includeIsPhotographed = false;

    //Methods
    vm.getSoldStockReport = getSoldStockReport;

    activate();

    function activate() {
        vm.sortorders = [
            { id: 1, description: $translate.instant('article.brand'), code: 'BrandCode' }, //'Varumärke'
            { id: 2, description: $translate.instant('article.maingroup'), code: 'MainGroupCode' }, //'Huvudgrupp'
            { id: 3, description: $translate.instant('article.articlename'), code: 'ArticleName' }, //'Produktnamn'
            { id: 4, description: $translate.instant('article.alternativearticlenumber'), code: 'AlternativeArticleNumber' }, //'Lev. produktnummer'
            { id: 5, description: $translate.instant('article.department'), code: 'Department' }, //'Avdelning'
            { id: 6, description: $translate.instant('common.variant1s'), code: 'VariantDetail1Name' }, //'Variant 1 (färg)'
            { id: 7, description: $translate.instant('common.variant2s'), code: 'VariantDetail2Name' }, //'Variant 2 (storlek)'
            { id: 8, description: $translate.instant('article.storageLocation'), code: 'StorageLocation' } //'Lagerplats'
        ];
        vm.sortOrder1 = vm.sortorders[0];
    }

    function getSoldStockReport() {
        var request = {
            startDate: vm.reportParameters.startDate,
            endDate: vm.reportParameters.endDate,
            locationIds: [],
            companyIds: [],
            languageCode: vm.printLanguage,
            sortOrder1: vm.sortOrder1 ? vm.sortOrder1.code : undefined,
            sortOrder2: vm.sortOrder2 ? vm.sortOrder2.code : undefined,
            sortOrder3: vm.sortOrder3 ? vm.sortOrder3.code : undefined
        };

        vm.selectedLocations.forEach(function(location) { request.locationIds.push(location.id); });
        vm.selectedCompanies.forEach(function(company) { request.companyIds.push(company.id); });

        loadSpinnerService.start("mainSpinner");
        StockApiService.downloadSoldStockReport(request).finally(function () {
            loadSpinnerService.stop("mainSpinner");
        });
    }
}

angular.module('stock.soldStockReports', [])
    .config(stateConfig)
    .controller('SoldStockReportsController', SoldStockReportsController);
